module.exports = __webpack_public_path__ + "img/imagem_workspace_checklist_primary.6c949e7e.png";